<template>
    <v-dialog
        v-model="dialog"
        persistent
        width="400px"
    >
        <div class="contentWrapper">
            <div>
                <v-btn
                    class="closeButton mx-2"
                    icon
                    title="Close Form"
                    @click="handleClose"
                >
                    <v-icon style="color: #4f4f4f !important" class="material-icons-round"> close </v-icon>
                </v-btn>
            </div>
            <!-- <div style="text-align: center">
                <img src = "/img/warning_info_icon.svg" style = "font-size: 38px; color: #3576C2;" class="cautionImageContainer material-icons-round">
            </div> -->
            <div style="padding-top: 24px;">
                <p class = "earningsText">Press confirm to withdraw or stay invested</p>
                <div class = "spanText">
                    By doing so, you will lose out on the current <strong>{{lenderPercentage}}% interest rate</strong> that you are earning.
                </div>
            </div>
            <div class = "buttonContainer">
                <button class="buttonCancel btn_new btn-secondary-new" @click="handleClose">Cancel </button>
                <button class="withdrawButton" @click="confirmWithdrawal">
                    Confirm
                </button>
                <!-- <button class="buttonSubmit btn_new btn-secondary-new">Yes, Confirm </button> -->
            </div>
        </div>
    </v-dialog>
</template>

<script>
export default {
    name: 'ConfirmPortfolioWithdrawal',
    props: {
        showConfirmDialog: {
            type: Boolean,
            default: false
        },
        lenderPercentage: {
            required: true
        }
    },
    data () {
        return {
            dialog: this.showConfirmDialog
        }
    },
    methods: {
        handleClose () {
            this.$emit('closeDialog')
        },
        confirmWithdrawal () {
            this.$emit('confirmWithdrawal')
        }
    }
}
</script>

<style scoped>
::v-deep .v-dialog {
    background-color: white;
}

.earningsText {
    text-align: center;
    margin-bottom: 4px !important;
    font-weight: 600;
    font-size: 16px;
    color: #0f0f0f
}
.spanText {
    color: #8c8c8c;
    text-align: center !important;
    font-size: 12px !important;
    padding: 12px;
}

.buttonContainer {
  padding-top: 20px;
  padding-bottom: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.buttonCancel {
  height: 40px !important;
  background: #e0e0e0 !important;
  border-color: #e0e0e0 !important;
  font-size: 14px !important;
  color: #232323 !important;
  margin-right: 10px !important;
  width: 120px !important;
}
button {
    padding: 11px 24px;
    border-radius: 6px;
    letter-spacing: 0.005em;
    font-size: 14px;
    line-height: 150%;
    font-weight: 600;
    width: 130px;

}

.withdrawButton {
    background: #002FA7;
    color: #FFFFFF;
}

.contentWrapper {
    padding: 12px;
    position: relative;
}

.closeButton {
    position: absolute;
    right: -4px;
    top: -2px;
}
.cautionImage {
    margin-left : 10px;
    width: 16px !important;
    height: 16px !important;
    cursor: pointer;
}
</style>
